import { isNil, isUndefined } from "lodash/fp";
import constants from "../../core/constants";

class Controller {
  constructor(Events) {
    "ngInject";

    this.Events = Events;
  }
  $onInit() {
    this.isDisabled = isNil(this.isDisabled) ? true : this.isDisabled;
    this.fields = this.fields || [];
    if (!isNil(this.responseDoneEventName)) {
      this.Events.on(
        this.responseDoneEventName,
        this.onResponseDone.bind(this)
      );
    }
  }

  enableFields() {
    this.isDisabled = false;
  }

  submitFields() {
    const result = {
      extraParams: this.extraParams,
      fields: this.constructFields(),
    };
    if (!isNil(this.eventName)) this.Events.emit(this.eventName, result);
  }

  onResponseDone() {
    this.isDisabled = true;
  }

  constructFields() {
    return this.fields.reduce((fields, currentField, idx) => {
      if (!isUndefined(currentField)) {
        const key = currentField.key || currentField.name || this.keys[idx];
        let value =
          currentField.id ||
          currentField._id ||
          (!isUndefined(currentField.value) && currentField.value) ||
          currentField.name ||
          currentField;
        if (!isUndefined(value) && currentField.currency) {
          value *= constants.currencyBy;
        }
        fields[key] = value;
      }
      return fields;
    }, {});
  }

  $onDestroy() {
    this.Events.off(this.responseDoneEventName, this.onResponseDone);
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/editableMultipleFields/editableMultipleFields.controller.js